export var GameCommand;
(function (GameCommand) {
    GameCommand["Nothing"] = "nothing";
    GameCommand["NewGame"] = "newGame";
    GameCommand["StartGame"] = "startGame";
    GameCommand["TakeTop"] = "takeTop";
    GameCommand["TakeDiscard"] = "takeDiscard";
    GameCommand["Discard"] = "discard";
    GameCommand["Knock"] = "knock";
    GameCommand["Pass"] = "pass";
    GameCommand["Layoff"] = "layoff";
    GameCommand["Undercut"] = "undercut";
    GameCommand["Scoring"] = "scoring";
    GameCommand["EndRound"] = "endRound";
    GameCommand["Next"] = "next";
})(GameCommand || (GameCommand = {}));
export class GameCommandData {
}
export class Action {
    constructor(command, commnadData, tablePosition, note) {
        this.command = GameCommand.Nothing;
        this.commandData = {};
        this.tablePosition = -1;
        this.note = "";
        this.command = command;
        if (commnadData)
            this.commandData = commnadData;
        if (tablePosition)
            this.tablePosition = tablePosition;
        if (note)
            this.note = note;
    }
}
export var GameEvent;
(function (GameEvent) {
    GameEvent["StateChanged"] = "stateChanged";
    GameEvent["RoundEnded"] = "roundEnded";
    GameEvent["RoundStageChanged"] = "roundStageChanged";
    GameEvent["GameOver"] = "gameOver";
    GameEvent["CardDiscarded"] = "cardDiscarded";
    GameEvent["TookDiscard"] = "tookDiscard";
    GameEvent["TookTop"] = "tookTop";
    GameEvent["Passed"] = "passed";
    GameEvent["CurrentPlayerChanged"] = "currentPlayerChanged";
    GameEvent["CardMoved"] = "cardMoved";
    GameEvent["InvalidAction"] = "invalidAction";
    GameEvent["PlayerChanged"] = "playerChanged";
})(GameEvent || (GameEvent = {}));
export var RoundStage;
(function (RoundStage) {
    RoundStage["PreGame"] = "preGame";
    RoundStage["Deal"] = "deal";
    RoundStage["FirstCard"] = "firstCard";
    RoundStage["MustTakeTop"] = "mustTakeTop";
    RoundStage["Draw"] = "draw";
    RoundStage["Discard"] = "discard";
    RoundStage["Knock"] = "knock";
    RoundStage["Layoff"] = "layoff";
    RoundStage["Undercut"] = "undercut";
    RoundStage["Scoring"] = "scoring";
    RoundStage["GameOver"] = "gameOver";
})(RoundStage || (RoundStage = {}));
export var CardPile;
(function (CardPile) {
    CardPile["Player1Hand"] = "hand0";
    CardPile["Player2Hand"] = "hand1";
    CardPile["Discard"] = "discard";
    CardPile["Draw"] = "draw";
})(CardPile || (CardPile = {}));
export class Player {
    constructor() {
        this.id = 0;
        this.name = '';
        this.avatar = '';
        this.type = '';
        this.level = '';
        this.tablePosition = 0;
        this.score = 0;
    }
}
export var PlayerPosition;
(function (PlayerPosition) {
    PlayerPosition[PlayerPosition["NoOne"] = -1] = "NoOne";
    PlayerPosition[PlayerPosition["Player1"] = 0] = "Player1";
    PlayerPosition[PlayerPosition["Player2"] = 1] = "Player2";
})(PlayerPosition || (PlayerPosition = {}));
export class RoundDetails {
    constructor() {
        this.results = "";
        this.playerToIncrease = -1;
        this.whoKnocked = -1;
        this.isBigGin = false;
        this.isGin = false;
        this.isKnocked = false;
        this.wasUndercut = false;
        this.difference = 0;
        this.player1Name = "";
        this.player2Name = "";
        this.player1Score = 0;
        this.player2Score = 0;
        this.player1Deadwood = 0;
        this.player2Deadwood = 0;
        this.ginPoints = 0;
        this.undercutPoints = 0;
        this.totalPoints = 0;
        this.winner = -1;
    }
}
//# sourceMappingURL=data:application/json;base64,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